// @owners { team: patients }
import { useEffect } from 'react';
import { updateOrder } from '~shared/actions/checkout';
import { getIsOrderBundling } from '~shared/features/checkout/selectors/getCheckoutFlow';
import { getOrderTipAmount } from '~shared/features/checkout/selectors/getOrder';
import { getTargetCheckoutTipAmount } from '~shared/features/courier-tips/checkoutTipPolicy';
import { getIsEditingExistingOrder } from '~shared/features/ui/selectors/getCart';
import { useDispatchShared, useSelectorShared } from '~shared/store';

/** Keeps `order.tip_amount` aligned with checkout eligibility and edit vs new order rules. */
export const useSyncCheckoutTip = ({ isTippable }: { isTippable: boolean }) => {
  const dispatch = useDispatchShared();
  const orderTipAmount = useSelectorShared(getOrderTipAmount);
  const isEditingOrder = useSelectorShared(getIsEditingExistingOrder);
  const isOrderBundling = useSelectorShared(getIsOrderBundling);

  useEffect(() => {
    if (isOrderBundling) return;

    const targetTipAmount = getTargetCheckoutTipAmount({
      isEditingOrder,
      isTippable,
      existingTipAmount: orderTipAmount,
    });

    if (orderTipAmount === targetTipAmount) return;

    dispatch(updateOrder({ tip_amount: targetTipAmount }));
  }, [dispatch, isEditingOrder, isOrderBundling, isTippable, orderTipAmount]);
};
